import { render, staticRenderFns } from "./PersonasTabJornada.vue?vue&type=template&id=1c7f97db&"
import script from "./PersonasTabJornada.vue?vue&type=script&lang=js&"
export * from "./PersonasTabJornada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports